module.exports = "../media/Proxima_Nova_Medium.otf";